/** Si el usuario está en un Mac, para enseñarle ⌘ en vez de Ctrl. */
export function isMac(): boolean {
    return typeof navigator !== 'undefined' && /mac/i.test(navigator.userAgent);
}

/** Atajo del buscador de secciones tal y como se teclea en cada sistema. */
export function searchShortcut(): string {
    return isMac() ? '⌘K' : 'Ctrl+K';
}
